module.exports = __webpack_public_path__ + "img/1522243438.96bd396f.jpg";